<template>
  <div class="equipment-control">
    <template v-for="item in data.socketList">
      <template v-if="item.dataType === 1">
        <water-quality :sensorData="item" :key="item.id" @clearAlame="clearAlame"></water-quality>
      </template>
      <template v-else-if="item.dataType === 2">
        <remote-control :switchData="item" :key="item.id + 1" @clearAlame="clearAlame"></remote-control>
      </template>
    </template>

    <!-- 警告声音 -->
    <audio ref="warm" loop="-1" preload="auto" muted controls="controls" id="music">
      <source :src="require('../../../public/warning.mp3')" />
    </audio>
  </div>
</template>

<script>
import WaterQuality from '@/components/v2/WaterQuality.vue'
import RemoteControl from '@/components/v2/RemoteControl.vue'
import equipmentV2 from '../../store/modules/equipmentV2'
import { mapState, mapActions, mapMutations } from 'vuex'
import mixins from '@/assets/js/mixins.js'
export default {
  name: 'EquipmentControl',
  mixins: [mixins],
  components: {
    WaterQuality,
    RemoteControl
  },
  data () {
    return {
      data: {},
      timer: null,
      second: 0,
      clearAvoice: 1800 // 半小时后警报声响
    }
  },
  watch: {
    equipmentData: {
      handler (value) {
        console.log(value, '???')

        let socketList = []
        value.sensorEquipments && value.sensorEquipments.forEach((item) => {
          item.dataType = 1
          socketList.push(item)
        })
        value.switchEquipments && value.switchEquipments.forEach((item) => {
          item.dataType = 2
          socketList.push(item)
        })
        socketList.sort((a, b) => {
          return a.name > b.name ? 1 : -1
        }).sort((a, b) => {
          return a.id > b.id ? 1 : -1
        }).sort((a, b) => {
          return b.powerStatus - a.powerStatus
        })
        value.socketList = socketList

        this.data = value
        this.checkAlame(value)
      }
      // immediate: true
    },
    basic: {
      handler (value) {
        if (value) {
          this.setActiveTitle(value.title)
        }
      },
      immediate: true
    }
  },
  computed: {
    ...mapState(equipmentV2, ['equipmentData', 'basic', 'currentEnterprise'])
  },
  async mounted () {
    function pagePc () {
      let rootValue = 100
      let pc = rootValue / 1920 // 表示1366的设计图,使用100px的默认值
      let width = window.innerWidth // 当前窗口的宽度
      let height = window.innerHeight // 当前窗口的高度
      let rem = ''
      let currentHeight = (width * 798) / 1920
      if (height < currentHeight) {
        // 当前屏幕高度小于应有的屏幕高度，就需要根据当前屏幕高度重新计算屏幕宽度
        width = (height * 1920) / 798
      }
      rem = width * pc // 以默认比例值乘以当前窗口宽度,得到该宽度下的相应font-size值
      document.documentElement.style.fontSize = rem + 'px'
    }

    pagePc()
    window.onresize = function () {
      pagePc()
    }
    // 获取当前数据
    let obj = JSON.parse(localStorage.getItem('currentBasic'))
    if (obj) {
      await this.getEquipmentsData(obj)
      this.setChooseBasic(obj)
    }
  },
  methods: {
    ...mapActions(equipmentV2, ['getEquipmentsData']),
    ...mapMutations(equipmentV2, ['setActiveTitle', 'setChooseBasic']),
    // 检查是否有警告值
    checkAlame (data) {
      let sensorAlarm
      let switchAlarm
      if (data.sensorEquipments) {
        sensorAlarm = data.sensorEquipments.some((item) => {
          if (item.alarmMessageList !== null) {
            return item.alarmMessageList.length > 0
          }
        })
      }
      if (data.switchEquipments) {
        switchAlarm = data.switchEquipments.some((item) => {
          if (item.alarmMessageList !== null) {
            return item.alarmMessageList.length > 0
          }
        })
      }
      // 水质和远程 某个有报警值  且 second为0 时 报警
      if ((sensorAlarm || switchAlarm) && this.second === 0) {
        this.playVoice()
      } else {
        clearInterval(this.timer)
        let audio = this.$refs.warm
        setTimeout(() => {
          audio.pause()
        }, 0)
      }
    },
    // 播放声音
    playVoice () {
      this.$nextTick(() => {
        let audio = this.$refs.warm
        setTimeout(() => {
          if (audio.paused) {
            // 判读是否播放
            // audio.paused=false;
            audio.play() // 没有就播放
          }
        }, 0)
      })
    },
    // 清除警报声
    clearAlame () {
      let audio = this.$refs.warm
      audio.pause()
      this.second = this.clearAvoice
      this.timer = setInterval(() => {
        --this.second
        if (this.second <= 0) {
          this.second = 0
          this.checkAlame(this.data)
          clearInterval(this.timer)
        }
      }, 1000)
    }
  },
  beforeDestroy () {
    clearInterval(this.timer)
    let audio = this.$refs.warm
    setTimeout(() => {
      audio.pause()
    }, 0)
  }
}
</script>

<style lang="scss">
.equipment-control {
  height: calc(100vh - 0.65rem);
  padding-bottom: 0.3rem;
  overflow: auto;
}
audio {
  width: 0px;
  height: 0px;
}
</style>
